import React from 'react';
import Loader from '../components/Loader';

const Loading = () => <Loader />;

export default Loading;
